<template>
  <div class="broadcast_box">
    <div class="broadcast_header">
      <div class="names no-arrow">
        <h2 class="broadcast_name no-arrow">
          <router-link :to="{ name: 'broadcast', params: { id: item._id } }">
            {{ item.name }}
          </router-link>
          <label>
            <span>(bcId: {{item._id}})</span>
          </label>
          <a v-if="isPairingDetails" @click="openPairingDetails()" class="pairing_info" title="Zobrazit informace o párování">Zobrazit informace o párování</a>
        </h2>
        <h2 v-if="item.episode" class="show_name">
          <template v-if="item.episode">
            {{ getEpisodeTitle(item.episode) }}
          </template>
        </h2>
      </div>
      <div class="broadcast_time">
        <span>
          {{ formatDateBroadcast(item.start) }} | {{ item.tvStation.name }}
        </span>
        <app-status-indicator class="program-item-status" :status="getStatusIndicator(item.state)" />
      </div>
    </div>
    <div class="original_data">
      <h3>Info o broadcastu</h3>
      <ul>
        <li v-for="(value, key) in originalDescription">
          <strong>{{ key }}</strong>
          <span>{{ value }}</span>
        </li>
      </ul>
      <strong v-if="item.descriptionShort">{{ translations.shortDescription }}</strong>
      <p class="description1" v-if="item.descriptionShort">
        {{ item.descriptionShort | shortenDescription }}
      </p>
      <strong v-if="item.descriptionLong">{{ translations.longDescription }}</strong>
      <p class="description2" v-if="item.descriptionLong">
        {{ item.descriptionLong | shortenDescription }}
      </p>
      <pre v-bind:style="{ display: showPairingDetails}">
        {{ JSON.stringify(item.pairingDetails, null, 2) }}
      </pre>
    </div>
    <div class="final_data">
      <div class="description_box">
        <ul>
          <li>
            <strong>{{translations.importTags}}</strong>
            <span>
              <template v-for="label in item.importLabels">
                <span :key="label._id" class="tag">{{ label }}</span>&nbsp;
              </template>
            </span>
          </li>
          <li v-if="item.show">
            <strong>{{translations.dbTags}}</strong>
            <span>
              <span v-if="item.show.formatLabelId" class="tag">
                {{ labels[item.show.formatLabelId] }}
              </span>&nbsp;
              <template v-if="item.show.contentLabelIds.length > 0" v-for="label in item.show.contentLabelIds">
                <span :key="label._id" class="tag">{{ labels[label] }}</span>&nbsp;
              </template>
            </span>
          </li>
          <li v-else>
            <strong>{{translations.dbTags}}</strong>
            <span>
              <span v-if="item.formatLabelId" class="tag">
                {{ labels[item.formatLabelId] }}
              </span>&nbsp;
              <template v-if="item.contentLabelIds.length > 0" v-for="label in item.contentLabelIds">
                <span :key="label._id" class="tag">{{ labels[label] }}</span>&nbsp;
              </template>
            </span>
          </li>
        </ul>
      </div>

      <div class="poster_box">
        <image-item
                :image="item.primaryPortrait"
                imageClass="poster"
                textClass="poster_text"
        />
        <image-item
                :image="item.primaryLandscape"
                imageClass="photo"
                textClass="photo_text"
        />
      </div>
    </div>
  </div>
</template>

<script>
import formatDateMixin from '../../../mixins/formatDateMixin'
import ImageItem from '../../TvProgram/ImageItem'

export default {
  name: 'program-item',
  components: {
    ImageItem
  },
  mixins: [formatDateMixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    labels: {
      type: Object,
      required: true
    },
    countries: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showPairingDetails: 'none',
      showShowPairingDetailsLink: 'block'
    }
  },
  computed: {
    translations() {
      return {
        dbTags: this.$gettext('Štítky z databáze:'),
        importTags: this.$gettext('Importní štítky:'),
        labels: this.$gettext('Štítky:'),
        country: this.$gettext('Stát:'),
        year: this.$gettext('Rok:'),
        duration: this.$gettext('Stopáž:'),
        rating: this.$gettext('Hodnocení:'),
        episodeName: this.$gettext('Název epizody:'),
        shortDescription: this.$gettext('Krátký popis'),
        longDescription: this.$gettext('Dlouhý popis'),
        importId: this.$gettext('Import ID:')
      }
    },
    originalDescription() {
      const obj = {}
      if (this.item) {
        obj[this.translations.labels] = this.item.labels ? this.item.labels : ''
        obj[this.translations.country] = this.broadcastCountries ? this.broadcastCountries : ''
        obj[this.translations.year] = this.item.year ? this.item.year : ''
        obj[this.translations.duration] = this.item.durationMinutes ? `${this.item.durationMinutes} min` : ''
        obj[this.translations.rating] = this.item.rating ? this.item.rating + '%' : ''
        obj[this.translations.episodeName] = this.item.episodeName ? this.item.episodeName : ''
        obj[this.translations.importId] = this.item.importId ? this.item.importId : ''
      }
      return obj
    },
    broadcastCountries() {
      let countries = ''

      for (let i = 0; i < this.item.countryIds.length; i++) {
        for (let j = 0; j < this.countries.length; j++) {
          if (this.item.countryIds[i] === this.countries[j]._id && this.countries[j].isoCode) {
            countries += this.countries[j].isoCode.toUpperCase()
            if (i + 1 !== this.item.countryIds.length) {
              countries += ', '
            }
          }
        }
      }

      return countries
    },
    isPairingDetails() {
      return this.item.pairingDetails.length === undefined
    }
  },
  methods: {
    getStatusIndicator(broadcastState) {
      switch (broadcastState) {
        case 'BROADCAST_STATE_UNASSIGNED':
          return 'red'
        case 'BROADCAST_STATE_UNVERIFIED':
          return 'orange'
        case 'BROADCAST_STATE_VERIFIED':
          return 'green'
        default:
          return 'pending'
      }
    },
    getEpisodeTitle(episode) {
      const seriesNum = String(episode.seriesNumber).padStart(2, '0')
      const episodeNum = String(episode.episodeNumber).padStart(2, '0')
      return ` / s${seriesNum}e${episodeNum} ${episode.name}`
    },
    openPairingDetails() {
      this.$emit('openPairingDetails', this.item)
    }
  }
}
</script>
